import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { exportFeatureKey } from './types';
import { EffectsModule } from '@ngrx/effects';
import {
  exportInitialState,
  exportReducer,
  IExportState,
} from './export.reducer';
import { ExportEffects } from './export.effects';
import { ExportApiService } from './export.api.service';
import { ExportService } from './export.service';

@NgModule({
  imports: [
    StoreModule.forFeature<IExportState>(exportFeatureKey, exportReducer, {
      initialState: exportInitialState,
    }),
    EffectsModule.forFeature([ExportEffects]),
  ],
  providers: [ExportApiService, ExportService],
})
export class StoreExportModule {}
